const textFunction = (text, morphemeNum) => {
  // const sub = [];
  // const verb = [];
  // const complement = [];
  // const direct_object = [];
  // const indirect_object = [];
  // const adverb = [];
  // const etc = [];
  // console.log(text)

  // const { sub, verb, complement, direct_object, indirect_object, adverb, etc } =
  //   morphemeNum;

  // const morphemeText = [
  //   sub,
  //   verb,
  //   complement,
  //   direct_object,
  //   indirect_object,
  //   adverb,
  //   etc,
  // ];
  // console.log(sub)

  const except = [".", ",", "?", "!", '"', "'"];

  const morphemeResult = [{ key: [], value: "", morpheme: 0 }];
  let count = 0;
  // console.log(morphemeResult.slice())

  for (let i = 0; i < text.length; i++) {
    // o'clock 예외사항 ------------------------
    if (
      text[i] === "o" &&
      text[i + 1] === "'" &&
      text[i + 2] === "c" &&
      text[i + 3] === "l" &&
      text[i + 4] === "o" &&
      text[i + 5] === "c" &&
      text[i + 6] === "k"
    ) {
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      count = count + 1;
      morphemeResult[count].key.push(i + 1, i + 2, i + 3, i + 4, i + 5, i + 6, i + 7);
      morphemeResult[count].value = "o'clock";
      // for (let n = 0; n < morphemeText.length; n++) {
      //   // console.log(morphemeText[n])
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        // console.log(key)
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
      count = count + 1;
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      i = i + 6;
      continue;
    }
    // Mrs. 예외사항 ------------------------
    if (
      text[i] === "M" &&
      text[i + 1] === "r" &&
      text[i + 2] === "s" &&
      text[i + 3] === "." &&
      text[i + 4] === " "
    ) {
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      count = count + 1;
      morphemeResult[count].key.push(i + 1, i + 2, i + 3, i + 4, i + 5);
      morphemeResult[count].value = "Mrs. ";
      // for (let n = 0; n < morphemeText.length; n++) {
      //   // console.log(morphemeText[n])
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
      count = count + 1;
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      i = i + 4;
      continue;
    }
    // Mr. 예외사항 ------------------------
    if (
      text[i] === "M" &&
      text[i + 1] === "r" &&
      text[i + 2] === "." &&
      text[i + 3] === " "
    ) {
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      count = count + 1;
      morphemeResult[count].key.push(i + 1, i + 2, i + 3, i + 4);
      morphemeResult[count].value = "Mr. ";
      // for (let n = 0; n < morphemeText.length; n++) {
      //   // console.log(morphemeText[n])
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
      count = count + 1;
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      i = i + 3;
      continue;
    }
    // n't 예외사항 ------------------------
    if (
      text[i] === "n" &&
      text[i + 1] === "'" &&
      text[i + 2] === "t" &&
      text[i + 3] === " "
    ) {
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      count = count + 1;
      morphemeResult[count].key.push(i + 1, i + 2, i + 3, i + 4);
      morphemeResult[count].value = "n't ";
      // for (let n = 0; n < morphemeText.length; n++) {
      //   // console.log(morphemeText[n])
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
      count = count + 1;
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      i = i + 3;
      continue;
    }
    // ---------------'축약 시 예외사항--------------------
    if (text[i] === "'") {
      const i1 = text[i + 1];
      const i2 = text[i + 2];
      const i3 = text[i + 3];

      if (
        i1 === "m" ||
        i1 === "s" ||
        i1 === "d" ||
        i1 === "r" ||
        i1 === "l" ||
        i1 === "v"
      ) {
        if (i2 === " ") {
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          count = count + 1;
          morphemeResult[count].key.push(i + 1, i + 2, i + 3);
          morphemeResult[count].value = `'${i1} `;
          // for (let n = 0; n < morphemeText.length; n++) {
          //   // console.log(morphemeText[n])
          //   if (morphemeResult[count].morpheme === 0) {
          //     if (
          //       morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1
          //     ) {
          //       continue;
          //     } else {
          //       morphemeResult[count].morpheme = n + 1;
          //       break;
          //     }
          //   } else {
          //     break;
          //   }
          // }
          for (let key in morphemeNum) {
            if(morphemeResult[count].morpheme === 0) {
              if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
                continue;
              } else {
                morphemeResult[count].morpheme = key
                break;
              }
            } else {
              break
            }
          }
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          i = i + 2;
          continue;
        } else if (i2 === "." && !i3 ) {
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          count = count + 1;
          morphemeResult[count].key.push(i + 1, i + 2);
          morphemeResult[count].value = `'${i1}`;
          for (let key in morphemeNum) {
            if(morphemeResult[count].morpheme === 0) {
              if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
                continue;
              } else {
                morphemeResult[count].morpheme = key
                break;
              }
            } else {
              break
            }
          }
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          i = i + 1;
          continue;
        } else {
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          count = count + 1;
          morphemeResult[count].key.push(i + 1, i + 2, i + 3, i + 4);
          morphemeResult[count].value = `'${i1 + i2} `;
          // for (let n = 0; n < morphemeText.length; n++) {
          //   // console.log(morphemeText[n])
          //   if (morphemeResult[count].morpheme === 0) {
          //     if (
          //       morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1
          //     ) {
          //       continue;
          //     } else {
          //       morphemeResult[count].morpheme = n + 1;
          //       break;
          //     }
          //   } else {
          //     break;
          //   }
          // }
          for (let key in morphemeNum) {
            if(morphemeResult[count].morpheme === 0) {
              if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
                continue;
              } else {
                morphemeResult[count].morpheme = key
                break;
              }
            } else {
              break
            }
          }
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          i = i + 3;
          continue;
        }
      }
    }
    //정규처리 로직
    // console.log(morphemeText)
    if (text[i] !== " " && except.indexOf(text[i]) === -1) {
      // console.log(morphemeResult.slice())

      morphemeResult[count].key.push(i + 1);
      morphemeResult[count].value += text[i];
      // for (let n = 0; n < morphemeText.length; n++) {
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
    } else if (text[i] === " ") {
      morphemeResult[count].key.push(i + 1);
      morphemeResult[count].value += text[i];
      // for (let n = 0; n < morphemeText.length; n++) {
      //   if (morphemeResult[count].morpheme === 0) {
      //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
      //       continue;
      //     } else {
      //       morphemeResult[count].morpheme = n + 1;
      //       break;
      //     }
      //   } else {
      //     break;
      //   }
      // }
      for (let key in morphemeNum) {
        if(morphemeResult[count].morpheme === 0) {
          if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
            continue;
          } else {
            morphemeResult[count].morpheme = key
            break;
          }
        } else {
          break
        }
      }
      count = count + 1;
      morphemeResult.push({ key: [], value: "", morpheme: 0 });
      continue;
    } else if (except.indexOf(text[i]) !== -1) {
      if (i === 0) {
        morphemeResult[count].key.push(i + 1);
        morphemeResult[count].value += text[i];
        count = count + 1;
        morphemeResult.push({ key: [], value: "", morpheme: 0 });
        continue;
      } else if (i === text.length - 1) {
        if (morphemeResult[count].key.length === 0) {
          morphemeResult[count].key.push(i + 1);
          morphemeResult[count].value += text[i];
          continue;
        } else {
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          morphemeResult[count].key.push(i + 1);
          morphemeResult[count].value += text[i];
          continue;
        }
      } else {
        if (morphemeResult[count].key.length === 0) {
          morphemeResult[count].key.push(i + 1);
          morphemeResult[count].value += text[i];
          // for (let n = 0; n < morphemeText.length; n++) {
          //   if (morphemeResult[count].morpheme === 0) {
          //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
          //       continue;
          //     } else {
          //       morphemeResult[count].morpheme = n + 1;
          //       break;
          //     }
          //   } else {
          //     break;
          //   }
          // }
          for (let key in morphemeNum) {
            if(morphemeResult[count].morpheme === 0) {
              if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
                continue;
              } else {
                morphemeResult[count].morpheme = key
                break;
              }
            } else {
              break
            }
          }
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          continue;
        } else {
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          morphemeResult[count].key.push(i + 1);
          morphemeResult[count].value += text[i];
          // for (let n = 0; n < morphemeText.length; n++) {
          //   if (morphemeResult[count].morpheme === 0) {
          //     if (morphemeText[n].indexOf(morphemeResult[count].key[0]) === -1) {
          //       continue;
          //     } else {
          //       morphemeResult[count].morpheme = n + 1;
          //       break;
          //     }
          //   } else {
          //     break;
          //   }
          // }
          for (let key in morphemeNum) {
            if(morphemeResult[count].morpheme === 0) {
              if(morphemeNum[key].indexOf(morphemeResult[count].key[0]) === -1) {
                continue;
              } else {
                morphemeResult[count].morpheme = key
                break;
              }
            } else {
              break
            }
          }
          count = count + 1;
          morphemeResult.push({ key: [], value: "", morpheme: 0 });
          continue;
        }
      }
    }
  }
  // console.log(morphemeResult)
  return morphemeResult;
};

export default textFunction;
